import type { CustomComponent } from '../../config/types.js'

export type CustomSaveDraftButton = CustomComponent
